import {defineMessages} from 'react-intl';

export default defineMessages({
    backdrop: {
        defaultMessage: 'Bối cảnh {index}',
        description: 'Default name for a new backdrop, scratch will automatically adjust the number if necessary',
        id: 'gui.sharedMessages.backdrop'
    },
    costume: {
        defaultMessage: 'Trang phục {index}',
        description: 'Default name for a new costume, scratch will automatically adjust the number if necessary',
        id: 'gui.sharedMessages.costume'
    },
    sprite: {
        defaultMessage: 'Sprite{index}',
        description: 'Default name for a new sprite, scratch will automatically adjust the number if necessary',
        id: 'gui.sharedMessages.sprite'
    },
    pop: {
        defaultMessage: 'pop',
        description: 'Name of the pop sound, the default sound added to a sprite',
        id: 'gui.sharedMessages.pop'
    },
    replaceProjectWarning: {
        id: 'gui.sharedMessages.replaceProjectWarning',
        defaultMessage: 'Thay thế nội dung của dự án hiện tại?',
        description: 'Confirmation that user wants to overwrite the current project contents'
    },
    clearCacheWarning: {
        id: 'gui.sharedMessages.clearCacheWarning',
        defaultMessage: 'Bạn có chắc chắn muốn xóa bộ nhớ cache và khởi động lại?',
        description: 'Confirmation that user wants clear cache'
    },
    loadFromComputerTitle: {
        id: 'gui.sharedMessages.loadFromComputerTitle',
        defaultMessage: 'Tải lên từ máy',
        description: 'Title for uploading a project from your computer'
    }
});
